import { render, staticRenderFns } from "./userData.vue?vue&type=template&id=9f89e2e2&scoped=true"
import script from "./userData.vue?vue&type=script&lang=js"
export * from "./userData.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/userData.scss?vue&type=style&index=0&id=9f89e2e2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f89e2e2",
  null
  
)

export default component.exports